export const gitCommit = '3c6f67c8'
